import { isDefined } from "@grandvisionhq/utils";
import { mapServerToVariantBase } from "./map-server-to-variant-base.js";
import { getBrandModelAttributes } from "../../../../utils/mappers/server-to-client/utils/get-brand-model-attributes.js";
import { mapServerToAccessoriesSpecifications } from "../../../../specification-mappers/mappers/server-to-client/specification-mappers/map-server-to-accessories-specifications.js";
const mapServerToAccessoriesVariant = (serverProduct, slug, locale, priceSegmentChannelKey) => {
  const { variants: serverVariants } = serverProduct;
  if (!serverVariants || !serverVariants.length) {
    return;
  }
  const clientVariants = serverVariants.map((serverVariant) => {
    const variantBase = mapServerToVariantBase(
      serverVariant,
      serverProduct,
      slug,
      locale,
      priceSegmentChannelKey
    );
    if (!variantBase) return;
    const otherFacet = serverVariant.variantTypeDetails.color.length === 0 && serverVariant?.variantTypeDetails.brandModelColorCode ? serverVariant?.variantTypeDetails.brandModelColorCode : void 0;
    const brandModelAttributes = getBrandModelAttributes(serverVariant);
    const accessory = {
      ...variantBase,
      ...brandModelAttributes,
      variantType: "accessories",
      facets: {
        color: serverVariant.variantTypeDetails.color[0],
        other: otherFacet
      },
      specifications: mapServerToAccessoriesSpecifications(serverVariant, serverProduct.brand),
      accessoryType: serverVariant.variantTypeDetails.accessoryType?.displayName ?? void 0
    };
    return accessory;
  });
  return clientVariants.filter(isDefined);
};
export {
  mapServerToAccessoriesVariant
};
//# sourceMappingURL=map-server-to-accessories-variant.js.map
